<div class="govuk-grid-row">
  <div class="govuk-grid-column-full">
    <p>You have been signed out.</p>

    <a [routerLink]="['/login']" role="button" draggable="false" class="govuk-button">
      Sign in
    </a>
  </div>
</div>
